import React from 'react';

const team = [
  {
    name: 'Mr. Mohan Shankar',
    role: 'Operations Director',
    desc: 'Mr. Mohan Shankar is an accomplished Operations Manager professional with over 25 years of extensive experience in the IT industry. As the Dynamic Director of EGB Systems & Solutions, USA, he has consistently demonstrated strong leadership, strategic vision, and operational excellence. A results-driven, self-motivated, and resourceful leader, Mr. Shankar possesses a proven track record of developing and strengthening management teams to maximize organizational profitability and efficiency. His expertise spans across multiple business sectors, enabling him to successfully lead and grow organizations into dynamic and progressive enterprises. With deep industry knowledge and a commitment to innovation, Mr. Shankar continues to drive business growth, operational success, and technological advancement, positioning the organization for sustained success in a competitive global market.',
  },
  {
    name: 'Shiva Prasath Palani',
    role: 'Director - Business Development and Production',
    desc: "Shiva Prasath Palani is the Director of Business Development and Production of EGB Systems and Solutions. Shiva is primarily responsible for managing the business development, production and marketing operations of the company. Shiva specialized in advanced web development, data analytics, and online marketing; and oversees the successful implementation of EGB's Services including web presence, web visibility and back office support team.",
  },
  {
    name: 'Chocklingam A.R.',
    role: 'Managing Director',
    desc: 'Chockalingam is a dynamic person with over 20+ years of experience in Offshore Development Center managing Global Delivery. He has a global experience of working with Tesco, UK. He has an extensive background and experience in Finance, Banking, Mergers and Acquisitions, Strategic Planning, Restructuring Operations, Export Marketing, Project, P&L, Account Management, Collaborations and Joint Ventures. He has proven ability to develop and strengthen management teams in order to maximize company profitability and efficiency.',
  },
  {
    name: 'Muthamizhchelvan. V',
    role: 'Manager - Technology',
    desc: 'At EGB, Muthamizhchelvan.V has applied his considerable talents in Software Product Technologies. He has very good experience and possesses strong knowledge in System Design and Architecture. With over 12+ years of experience in Software Engineering, Muthu has designed and developed various Web and Software Applications, Database Designing, Maintenance, applied Security Standards, Project Planning and Leading Team. Muthamizhchelvan is also strong in Project Management and Agile/Scrum Methodology.',
  },
];

const ManagementTeam = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Management Team</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>The people behind EGB's success</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {team.map((member, i) => (
            <div key={i} className="col-12">
              <div className="card border-0 shadow-sm p-4">
                <div className="d-flex align-items-start gap-4">
                  <div style={{ background: '#dbeafe', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 32 }}>
                    👤
                  </div>
                  <div>
                    <h4 className="fw-bold mb-1">{member.name}</h4>
                    <span className="badge bg-primary mb-3">{member.role}</span>
                    <p className="text-muted mb-0" style={{ lineHeight: 1.8 }}>{member.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default ManagementTeam;
